module.exports = __webpack_public_path__ + "img/IMG_8279.8920f216.jpg";